
<template>
<v-card flat color="#f5f5f5" height="100%">
    <v-container fluid :class="{ 'px-0': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <!-- start upload photos-->

        <v-card>
            <div class="" style="position: relative; height: 3px">
                <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
            </div>
            <div class="text-center">
                <input type="file" ref="fileInput" multiple accept="image/*" @change="onFileChanged" class="input-file">
                Drag your file here to begin<br> or click to browse
            </div>
        </v-card>

        <v-row no-gutters>
            <v-col md="3" cols="6" v-for="(photo, index) in all_photos" :key="index" class="pa-2 text-center">
                <div style="position: relative">
                    <v-img :src="photo.url" height="200" cover />
                    <v-btn color="blue darken-2" @click="openDeletePhoto(photo, index)" small fab absolute right style="top: 7px">
                        <v-icon medium color="red">delete_outline</v-icon>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
        <!-- end upload photos-->

    </v-container>
    <slot name="actions"></slot>

    <!--delete dialog photo-->
    <v-dialog v-model="dialog_photo" max-width="320">
        <v-card>
            <v-card-text class="pt-2">
                Are you sure you want to delete this photo?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" @click="destroyPhoto()">
                    Delete
                </v-btn>
                <v-btn color="primary" text @click="cancelDelete()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog photo-->
</v-card>
</template>

<script>
import {
    mapActions
} from "vuex";
import defaults from "../../utils/PropDefaults.js";
export default {
    components: {},
    props: {
        item: {
            type: Object,
            default: function () {
                return this.$clone(defaults.place_item)
            }
        },
    },

    data() {
        return {
            // start upload photos + show photos
            all_photos: [],
            new_photos: [],
            unique_ids: [],
            dialog_photo: false,
            loading: false,
            current_photo: this.$clone(defaults.photo_item),
            current_index: null,

        };
    },

    created() {
        this.unique_ids = [];
        if(!this.item.id) {
            this.all_photos = [];
            this.new_photos = [];
        } else {
            this.getPhotos(this.item.id)
        }
    },

    watch: {
        item: {
            handler() {
                this.unique_ids = [];
                if(!this.item.id) {
                    this.all_photos = [];
                    this.new_photos = [];
                } else {
                    this.getPhotos(this.item.id)
                }
            }
        },
        new_photos: {
            handler() {
                this.$emit("addPhoto", this.new_photos)
            }
        }
    },

    methods: {

        ...mapActions("alert", ["success", "error"]),

        clearPhotos() {
            this.all_photos = [];
            this.new_photos = [];
        },

        getPhotos(place_id) {
            this.loading = true;
            // prepare stamp & save current_stamp
            let stamp = Date.now();
            // setup query params
            let params = {
                params: {
                    place_ids: [place_id],
                    stamp: stamp
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

            this.$axios.get(endpoint, params)
                .then(response => {
                    // Array.prototype.push.apply(this.all_photos, response.data.data);
                    this.all_photos = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        onFileChanged(event) {
            const files = event.target.files || event.dataTransfer.files;
            if(!files.length) {
                return;
            }

            Array.prototype.forEach.call(files, file => {
                this.createImage(file);
            });
        },

        generateUniqueId() {
            let nr_id = Math.floor((Math.random() * 10000) + 1);
            if(this.unique_ids.includes(nr_id)) {
                this.generateUniqueId();
            } else {
                this.unique_ids.push(nr_id)
                return nr_id
            }
        },

        createImage(file) {
            let id = this.generateUniqueId();
            const fileReader = new FileReader();
            fileReader.onload = event => {
                this.all_photos.push({
                    id: 'abc' + id,
                    url: event.target.result,
                });
                this.new_photos.push({
                    id: 'abc' + id,
                    place_id: this.item.id,
                    photo: event.target.result,
                    description: this.item.name_real,
                    title: this.item.name_real,
                    status: "pending",
                    order: "50"
                });

            };
            fileReader.readAsDataURL(file);
        },

        destroyPhoto() {

            let value = this.current_photo.id.toString();
            if(value.includes("abc")) {
                // photo is a new one added
                let index = this.all_photos.findIndex(item => item.id === this.current_photo.id);
                this.all_photos.splice(index, 1);

                let new_index = this.new_photos.findIndex(item => item.id === this.current_photo.id);
                this.new_photos.splice(new_index, 1);

                this.current_photo = null;
                this.dialog_photo = false;
            } else {
                // photo is an old one and we need to call api
                let index = this.all_photos.findIndex(item => item.id === this.current_photo.id);
                // setup query endpoint
                let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
                let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

                // call delete endpoint

                this.$axios.delete(endpoint + "/" + this.current_photo.id) // eslint-disable-next-line
                    .then(response => {
                        this.all_photos.splice(index, 1);
                        this.success("Photo deleted!");
                    })
                    .catch(error => {
                        console.error(error);
                        this.error("Oops, something went wrong!");
                    })
                    .finally(() => {
                        this.current_photo = null;
                        this.dialog_photo = false;
                    });
            }
        },

        selectPlace(place) {
            if(place) {
                this.item.place_id = place.id;
            } else {
                this.item.place_id = null;
            }
        },

        openDeletePhoto(photo, index) {
            this.current_photo = photo;
            this.dialog_photo = true;
        },

        cancelDelete() {
            this.current_photo = null;
            this.dialog_photo = false;
        },

        savePhoto(index, place_id) {

            if(this.new_photos[index].id) {
                this.savePhoto(index + 1, place_id);
            }
            this.new_photos[index].place_id = place_id;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/destinations/photos";

            setTimeout(() => {
                this.$axios.post(endpoint, this.new_photos[index])
                    .then(response => {
                        this.success("Poza a fost editata!");
                    })
                    .catch(error => {
                        console.log(error);
                        this.error("A aparut o eroare!");
                    })
                    .finally(() => {
                        if(index < this.new_photos.length - 1) {
                            this.savePhoto(index + 1, article_id);
                        } else {
                            this.photos = [];
                            this.loading_save = false;
                        }
                    });
            }, 1000);
        },

    }
};
</script>
